import * as ko from "knockout";
import {IMessageData, IRouteDefinitionParams, ISystem} from '../../index';
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import {createErrorMessage} from "../../util/misc";
import {getObjectFromRouteData} from "../../util/request";
import {nsRoute} from "../../util/route";
import {ButtonManager} from "../../util/ButtonManager";
import {REQUEST_MESSAGE} from "../../constants/Language";
import pubsub from "../../pubsub";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import detailsHtml from './details.html?raw';

export let template = detailsHtml;

export class viewModel extends ParsedRouteDataDecorator {
    protected messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    protected isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    protected d!: ISystem;
    protected readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    protected readonly pageButtons: ButtonManager = new ButtonManager()

    constructor(params: IRouteDefinitionParams) {
        super(params);
        pubsub.on(this, 'collection.needs.refresh', this.init.bind(this));
        this.initButtons()
        setTimeout(() => this.init());
    }

    protected initButtons() {}

    protected init() {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        this.__requestRouteData!
            .request()
            .then(this.onGetSuccess.bind(this))
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
            })
        ;
    }

    protected onGetSuccess(data: ISystem[]) {
        this.d = getObjectFromRouteData(data, this.__routeDef, this.__routeParams);
        if (!this.d) {
            this.messageData(createErrorMessage('data not available'));
            return;
        }
        this.messageData(null);
        this.isReady(true);
    }

    override dispose() {
        super.dispose();
        this.kosub.unsuscribeAll();
        pubsub.off(this)
    }
}
